import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ className = "", light = false, testId = "site-logo" }) => {
  return (
    <Link
      to="/"
      data-testid={testId}
      className={`inline-flex items-center select-none ${className}`}
      aria-label="HepCURE home"
    >
      <img
        src={light ? "/brand/hepcure-logo-white.png" : "/brand/hepcure-logo.png"}
        alt="HepCURE"
        className="h-full w-auto object-contain"
        draggable="false"
      />
    </Link>
  );
};

export default Logo;
